<template>
  <div class="invoice-view">
    <v-card flat>
      <ReportViewBar
        :title="`Payments`"
        :location="location"
        :start="dateTime.start"
        :end="dateTime.end"
      />
      <v-card-text>
        <v-layout row wrap class="no-print">
          <v-flex xs12 md3>
            <v-select
              :items="groupList"
              return-object
              :disabled="removeGroup"
              v-model="selectedGroup"
              hide-details
              item-text="name"
              outlined
            ></v-select>
            <v-checkbox
              label="Remove Group"
              hide-details
              v-model="removeGroup"
            ></v-checkbox>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 md3>
            <DateTimePicker
              :defaultRange="selectedRange"
              :range="true"
              v-model="dateTime"
              :initStartDate="start"
              :initEndDate="end"
              @submit="loadReports()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-progress-linear
        v-if="loading"
        :indeterminate="true"
      ></v-progress-linear>
      <div v-else>
        <v-container fluid v-if="!removeGroup">
          <v-expansion-panel
            focusable
            :expand="expand"
            popout
            class="elevation-0"
          >
            <v-expansion-panel-content
              lazy
              v-for="(invoice, i) in Object.keys(reportsData)"
              :key="i"
            >
              <template v-slot:header>
                <v-layout row wrap>
                  <v-flex>
                    <h2 class="title font-weight-regular">
                      {{ invoice }} ({{
                        Object.entries(reportsData)[i][1].length
                      }})
                    </h2>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-right mr-2" shrink>
                    <h2 class="title font-weight-regular">
                      {{ getTotal(i) | currency }}
                    </h2>
                  </v-flex>
                </v-layout>
              </template>

              <v-divider></v-divider>

              <Payments
                :Headers="headers"
                :Payments="Object.entries(reportsData)[i][1]"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-divider></v-divider>
          <v-card flat class="px-5" color="grey lighten-4">
            <v-card-text>
              <v-layout row wrap>
                <v-flex>
                  <h2 class="headline font-weight-regular">
                    {{ $t("labels.total") }}
                  </h2>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="text-right mr-2" shrink>
                  <h2 class="headline font-weight-regular">
                    {{ report_grandTotal_total | currency }}
                  </h2>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
        <v-container fluid v-else>
          <Payments :Headers="headers" :Payments="invoicesUnGroup" />
        </v-container>
      </div>

      <v-card-text v-if="reportsData.length === 0">
        <div class="text-center mb-5">No Product Found</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import DateTimePicker from "@/components/DateTimePicker";
import locationService from "@/modules/Location/service";
import Invoice from "../../GlobalReport/Invoice";
import Payments from "./payments";
import reportService from "../../../Reports/service";

export default {
  data() {
    return {
      selectedRange: "thisMonth",
      removeGroup: false,
      expand: false,
      reportsData: [],
      invoicesUnGroup: [],
      groupList: [
        { id: 1, name: "Payment Method", key: "paymentMethodName" },
        { id: 2, name: "Create Date", key: "createdAt" },
        { id: 3, name: "Employee", key: "employee" },
        { id: 4, name: "Customer", key: "customer" },
      ],
      selectedGroup: {
        id: 1,
        name: "Payment Method",
        key: "paymentMethodName",
      },
      start: this.$moment().startOf("day"),
      end: this.$moment().endOf("day"),
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      loading: false,
      location: null,
      locationId: null,
      headers: [
        {
          text: this.$t("labels.date"),
          align: "left",
          sortable: false,
          value: "createdAt",
          width: "20%",
        },
        {
          text: this.$t("labels.employeeName"),
          value: "employeeName",
          sortable: false,
        },
        {
          text: this.$t("labels.invoice"),
          value: "localId",
          sortable: false,
        },
        {
          text: this.$t("labels.refernceNumber"),
          value: "referenceNumber",
          sortable: false,
        },
        {
          text: this.$t("labels.amount"),
          value: "amount",
          align: "right",
          sortable: false,
        },
      ],
    };
  },
  components: {
    DateTimePicker,
    ReportViewBar,
    Payments,
    Invoice,
  },
  watch: {
    selectedGroup(val) {
      this.groupBy(val.key);
    },
  },
  created() {
    const { start, end, range, LocationId } = this.$route.query;
    this.locationId = LocationId;
    if (this.locationId) {
      locationService
        .getbyId(this.locationId)
        .then((response) => {
          this.location = response.data;
        })
        .catch((error) => {
          throw error;
        });
    }
    if (start && end) {
      this.dateTime.start = start;
      this.dateTime.end = end;
      console.log(start, end, range);
    } else {
      this.dateTime.start = this.$moment().startOf("month").toISOString();
      this.dateTime.end = this.$moment().endOf("month").toISOString();
    }
    this.selectedRange = range;
    this.loadReports();
  },
  computed: {
    report_grandTotal_total() {
      let total = 0;
      this.invoicesUnGroup.map((row) => {
        total += parseFloat(row.amount);
      });
      return total;
    },
  },
  methods: {
    groupBy(key) {
      switch (key) {
        case "paymentMethodName":
          this.reportsData = _.mapValues(
            _.groupBy(
              this.invoicesUnGroup,
              (invoice) => invoice.paymentMethodName
            ),
            (list) => list
          );
          break;
        case "createdAt":
          this.reportsData = _.mapValues(
            _.groupBy(this.invoicesUnGroup, (invoice) =>
              this.$moment(invoice.createdAt).format("MM/DD/YYYY")
            ),
            (list) => list
          );
          break;
        case "employee":
          this.reportsData = _.mapValues(
            _.groupBy(
              this.invoicesUnGroup,
              (invoice) => invoice.Employee.firstName
            ),
            (list) => list
          );
          break;
        case "customer":
          this.reportsData = _.mapValues(
            _.groupBy(this.invoicesUnGroup, (invoice) =>
              invoice.Contact ? invoice.Contact.firstName : "Walk-in Customer"
            ),
            (list) => list
          );
          break;
        default:
          this.reportsData = _.mapValues(
            _.groupBy(this.invoicesUnGroup, (invoice) =>
              this.$moment(invoice.createdAt).format("MM/DD/YYYY")
            ),
            (list) => list
          );
          break;
      }
    },
    getTotal(i) {
      let total = 0;
      Object.entries(this.reportsData)[i][1].map((invoice) => {
        total += parseFloat(invoice.amount);
      });
      return total;
    },
    async loadReports() {
      this.loading = true;
      await reportService.Location.payments({
        LocationId: this.locationId,
        start: this.dateTime.start,
        end: this.dateTime.end,
      })
        .then((response) => {
          if (response.data) {
            const data = response.data.map((invoice) => invoice.Payments);
            this.invoicesUnGroup = [].concat(...data);
          }
          const promise = new Promise((resolve, reject) => {
            this.invoicesUnGroup.map((invoice) => {
              invoice.paymentMethodName = null;
              invoice.payment = {
                cash: 0,
                debit: 0,
                credit: 0,
                account: 0,
                other: 0,
              };
              switch (invoice.PaymentMethodId) {
                case 1:
                  invoice.payment.cash += parseFloat(invoice.amount);
                  invoice.paymentMethodName = "Cash";
                  break;
                case 2:
                  invoice.payment.credit += parseFloat(invoice.amount);
                  invoice.paymentMethodName = "Credit Card";
                  break;
                case 3:
                  invoice.payment.debit += parseFloat(invoice.amount);
                  invoice.paymentMethodName = "Debit Card";
                  break;
                case 4:
                  invoice.payment.account += parseFloat(invoice.amount);
                  invoice.paymentMethodName = "Account";
                  break;
                default:
                  invoice.payment.other += parseFloat(invoice.amount);
                  invoice.paymentMethodName = "Other";
              }
            });
            resolve(true);
          });

          this.groupBy(this.selectedGroup.key);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
  },
};
</script>

<style>
</style>
